import { ETF, Fund } from './entities';

export class ETFStore {
  private etfs?: ETF[];
  private funds?: Fund[]; // These are the funds within etfs
  private etfMap?: Map<number | string, ETF>;
  private fundsMap?: Map<number | string, Fund>;

  constructor() {
    this.etfs = undefined;
    this.funds = undefined;
  }

  public getFunds = (): Fund[] | undefined => {
    return this.funds;
  };

  public updateFunds = (funds: Fund[]): Fund[] => {
    this.funds = funds;
    return funds;
  };

  public updateFund = (fund: Fund): Fund => {
    if (!this.fundsMap) {
      this.fundsMap = new Map<number, Fund>();
    }
    this.fundsMap.set(fund.id, fund);
    return fund;
  };

  getFund = (id: number | string): Fund | undefined => {
    if (!this.fundsMap) {
      this.fundsMap = new Map<number, Fund>();
      this.funds?.forEach(fund => {
        this.fundsMap?.set(fund.id, fund);
      });
    }
    return this.fundsMap.get(id);
  };

  public getETFs = (): ETF[] | undefined => {
    return this.etfs;
  };

  public getETF = (id: number | string): ETF | undefined => {
    if (!this.etfMap) {
      this.etfMap = new Map<number, ETF>();
      // This will cache the ETFs in a map for faster lookup
      // if they are looking at a specific ETF after the index page
      this.etfs?.forEach(fund => {
        this.etfMap?.set(fund.id, fund);
      });
    }
    return this.etfMap.get(id);
  };

  public updateETFs = (etfs: ETF[]): ETF[] => {
    this.etfs = etfs;
    return etfs;
  };

  public updateETF = (fund: ETF): ETF => {
    if (!this.etfMap) {
      this.etfMap = new Map<number, ETF>();
    }
    this.etfMap.set(fund.id, fund);
    return fund;
  };
}
